import React, { useEffect, useState } from 'react';

const CustomBackground = () => {
  const [settings, setSettings] = useState({
    imageUrl: 'http://192.168.178.47:5000/api/media-images/mal/90125_poster.jpg',
    blur: 10,
    opacity: 0.7,
    coverType: 'cover',
  });
  const [customBackground, setCustomBackground] = useState(false);

  useEffect(() => {
    const storedSettings = localStorage.getItem('backgroundSettings');
    if (storedSettings) {
      setSettings(JSON.parse(storedSettings));
    }
    const storedCustomBackground = localStorage.getItem('customBackground');
    setCustomBackground(storedCustomBackground === 'true');
  }, []);

  if (!customBackground) return null;

  const { imageUrl, blur, opacity, coverType } = settings;

  const style = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -2,
    opacity,
    ...(coverType === 'tile'
      ? {
          backgroundImage: `url(${imageUrl})`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
        }
      : {
          objectFit: coverType === 'cover' ? 'cover' : 'fill',
        }),
    ...(coverType !== 'tile' && { filter: `blur(${blur}px)` }),
  };

  return coverType === 'tile' ? (
    <div className="custom-background" style={style} />
  ) : (
    <img src={imageUrl} alt="custom-background" className="custom-background" style={style} />
  );
};


export default CustomBackground;